import { useMutation } from "react-query";
import { configSrore } from "../configSrore";
import { ERequest } from "../interface";
import Fetch from "../utils/fetch";

export default function useShareFileHash() {
  return useMutation(
    async (values: {
      page: number;
      fileHash: string;
      userGroupHash: string;
      callBack?: () => void;
    }) => {
      const { fileHash, userGroupHash } = values;
      await Fetch({
        url: `${configSrore.clasorUrl}files/shareHash`,
        method: ERequest.POST,
        data: {
          fileHash,
          userGroupHash,
        },
      });
    },
    {
      onSuccess: (_result, values) => {
        const { callBack } = values;
        callBack?.();
      },
    },
  );
}
